import AbstractNetworkStatus from '../all/AbstractNetworkStatus';
import logger from 'src/utils/logger/logger';

class HisenseNetworkStatus extends AbstractNetworkStatus {

  constructor() {
    super();
  }

  isOnline() {
    // Hisense dont work with navigator online
    logger.debug('[NetworkStatus] checking Hisense...');
    return this.onlineByAjax();
  }

}

export default HisenseNetworkStatus;



// WEBPACK FOOTER //
// ./src/devices/hisense/NetworkStatus.js